<template>
    <div class="wrapper" id="cookieBanner">
        <div class="cookie-banner">
            <!-- <transition name="fade">
                <div class="cookie-banner__selections" v-if="showSelection">
                    <div class="cookie-banner__selections__option">
                        <div>
                            <h2 class="necessary-heading">{{$t('COOKIE_BANNER_NECESSARY')}}</h2>
                        </div>
                        <p class="cookie-content">{{$t('COOKIE_BANNER_NECESSARY_DESCRIPTION')}}</p>
                    </div>
                    <div class="cookie-banner__selections__option">
                        <div class="switch-heading">
                            <div class="switch-wrapper">
                                <label class="switch" :class="!cookiePreferences.preferences ? 'switch-off' : ''">
                                    <input type="checkbox" v-model="cookiePreferences.preferences" />
                                    <div></div>
                                </label>
                            </div>
                            <h2>{{$t('COOKIE_BANNER_PREFERENCES')}}</h2>
                        </div>
                        <p class="cookie-content">{{$t('COOKIE_BANNER_PREFERENCES_DESCRIPTION')}}</p>
                    </div>
                    <div class="cookie-banner__selections__option">
                        <div class="switch-heading">
                            <div class="switch-wrapper">
                                <label class="switch" :class="!cookiePreferences.analytics ? 'switch-off' : ''">
                                    <input type="checkbox" v-model="cookiePreferences.analytics" />
                                    <div></div>
                                </label>
                            </div>
                            <h2>{{$t('COOKIE_BANNER_ANALYTICS')}}</h2>
                        </div>
                        <p class="cookie-content">{{$t('COOKIE_BANNER_ANALYTICS_DESCRIPTION')}}</p>
                    </div>
                    <div class="cookie-banner__selections__option">
                        <div class="switch-heading">
                            <div class="switch-wrapper">
                                <label class="switch" :class="!cookiePreferences.tracking ? 'switch-off' : ''">
                                    <input type="checkbox" v-model="cookiePreferences.tracking" />
                                    <div></div>
                                </label>
                            </div>
                            <h2>{{$t('COOKIE_BANNER_MARKETING')}}</h2>
                        </div>
                        <p class="cookie-content">{{$t('COOKIE_BANNER_MARKETING_DESCRIPTION')}}</p>
                    </div>
                </div>
            </transition> -->

            <div class="cookie-banner__info-section">
                <div class="cookie-banner__info-section--content">
                    <p class="cookie-content">
                        <span v-html="$t('COOKIE_BANNER_STATEMENT_NEW')"></span>
                        <a class="cookie-content__link" href="https://www.freddiesflowers.com/privacy-policy" v-html="$t('KNOW_MORE')"></a>
                    </p>
                </div>

                <div class="cookie-banner__info-section--controls">
                    <!-- <button
                        class="cookie-btn--secondary"
                        v-text="showSelection ? $t('COOKIE_BANNER_MINIMIZE') : $t('COOKIE_BANNER_MANAGE')"
                        @click="expandBanner()"
                        type="button">
                    </button> -->

                    <button
                        class="cookie-btn--primary"
                        v-text="$t('COOKIE_BANNER_ACCEPT')"
                        @click="onApplyCookies()"
                        type="button">
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CookieBanner',
    data() {
        return {
            cookiePreferences: {
                analytics: true,
                necessary: true,
                preferences: true,
                tracking: true,
            },
            showSelection: false,
        };
    },
    computed: {
        ...mapGetters({
            preferences: 'cookies/getCookiePreferences',
        }),
    },
    mounted() {
        // this.cookiePreferences = this.preferences ? this.preferences : this.cookiePreferences;
        this.acceptCookies();
    },
    methods: {
        acceptCookies() {
            this.$store.commit('cookies/setCookiePreferences', this.cookiePreferences);
            this.$store.dispatch('cookies/mountScripts');
        },
        onApplyCookies() {
            this.$store.commit('cookies/hideCookieBanner');
        },

        expandBanner() {
            this.showSelection = !this.showSelection;
        },
    },
};
</script>

<style lang="scss" scoped>
$darkGrey: #666666;
$black: #343E47;
$background: #343E47;

.wrapper {
    background: $background;
    width: 100%;
    left: 0;
    top: 0;
    color: #fff;
    display: flex;

    @media screen and (min-width: 768px) {
        min-height: 100px;
    }

    .cookie-banner {
        align-self: center;
        margin: 0 auto;

        h2 {
            font-size: 20px;
            margin: 0;
            line-height: 20px;
        }

        .necessary-heading {
            margin-bottom: 10px;
        }

        .cookie-content {
            font-weight: 400;
            font-size: 14px;
            line-height: 20px;
            margin: 0 auto;
            @media screen and (min-width: 768px) {
                font-size: 18px;
            }
            &__link {
                text-decoration: underline;
                margin: 0 10px;
                font-weight: 400;
                font-size: 18px;
                line-height: 20px;
                @media screen and (max-width: 768px) {
                        font-size: 14px;
                    }
            }
        }

        &__info-section {
            display: grid;
            grid-template-columns: 70% 30%;

            @media screen and (min-width: 768px) {
                display: inline-flex;
            }

            &--content {
                padding: 10px 10px;

                @media screen and (min-width: 1280px) {
                    padding-top: 10px;
                    margin-right: 125px;
                }
            }

            &--controls {
                text-align: center;

                .cookie-btn--primary, .cookie-btn--secondary {
                    max-width: 100px;
                    height: 49px;
                    padding: 10px 15px;
                    line-height: 6px;
                    border-radius: 4px;
                    font-size: 17px;
                    color: #fff;
                }

                .cookie-btn--primary {
                    border: 1px solid white;
                    margin: 0.5rem;
                    margin-right: 20px;

                    @media screen and (min-width: 768px) {
                        width: 144px;
                        font-size: 20px;
                    }
                }

                .cookie-btn--secondary {
                    background-color: $background;
                    border: 2px solid $black;
                    outline: 0;
                    margin: 0.5rem;

                    @media screen and (min-width: 768px) {
                        width: 170px;
                        font-size: 20px;
                    }
                }
            }
        }

        // &__selections {
        //     display: grid;
        //     grid-template-columns: 100%;
        //     width: 100%;
        //     padding: 10px 20px;

        //     @media screen and (min-width: 768px) {
        //         margin-bottom: 31px;
        //         display: inline-flex;
        //         gap: 15px;
        //     }

        //     &__option {
        //         margin: 0 auto;
        //         flex-basis: 100%;
        //         margin-top: 15px;

        //         .switch-heading {
        //             display: inline-flex;

        //             .switch-wrapper {
        //                 margin-right: 15px;
        //             }

        //             .switch input {
        //                 position: absolute;
        //                 opacity: 0;
        //             }

        //             .switch {
        //                 display: inline-block;
        //                 font-size: 20px;
        //                 height: 20px;
        //                 width: 40px;
        //                 background: $black;
        //                 border-radius: 1em;
        //                 cursor: pointer;
        //             }

        //             .switch-off {
        //                 background: $darkGrey;
        //             }

        //             .switch div {
        //                 height: 20px;
        //                 width: 20px;
        //                 border-radius: 1em;
        //                 background: #FFF;
        //                 box-shadow: 0 0.1em 0.3em rgba(0,0,0,0.3);
        //                 -webkit-transition: all 300ms;
        //                 -moz-transition: all 300ms;
        //                 transition: all 300ms;
        //             }

        //             .switch input:checked + div {
        //                 -webkit-transform: translate3d(100%, 0, 0);
        //                 -moz-transform: translate3d(100%, 0, 0);
        //                 transform: translate3d(100%, 0, 0);
        //             }
        //         }
        //     }
        // }
    }
}
</style>
